export const rootStyles = {
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const accordionStyles = {
  boxShadow: 'none',
  '&:before': { display: 'none' },
};

export const groupsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const groupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const groupLabelStyles = {
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const getItemRowStyles = isActive => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  padding: '4px 8px',
  borderRadius: '8px',
  textAlign: 'left',
  backgroundColor: isActive ? 'action.hover' : 'transparent',

  '&:hover': {
    backgroundColor: 'action.hover',
  },
});

export const itemLabelStyles = {
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const activeFilterRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  padding: '8px 24px',
  backgroundColor: 'action.hover',
};

export const countQualifierIconStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  color: 'text.secondary',
};
